import { useEffect } from "react";
import { getCourse, GET_COURSE_BY_ID, GET_SUB_GROUP, getSubGroup } from "..";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { getSelectedProgram } from "utils";

export const useCourse = ({ type = null }) => {
  const navigate = useNavigate();

  let selectedProgram = getSelectedProgram();
  let { studentBatchId } = !!selectedProgram && selectedProgram;

  let selectedCourseGroup = sessionStorage.getItem("courseGroup")
    ? JSON.parse(sessionStorage.getItem("courseGroup"))
    : null;
  let { id: courseGroupId, hasSubGroups, name } =
    !!selectedCourseGroup && selectedCourseGroup;

  let courseListStorage = sessionStorage.getItem("courseList")
    ? JSON.parse(sessionStorage.getItem("courseList"))
    : null;
  let { hasCourseGroup, displayName } =
    !!courseListStorage && courseListStorage;

  let selectedCourseSubGroup = sessionStorage.getItem("courseSubGroup")
    ? JSON.parse(sessionStorage.getItem("courseSubGroup"))
    : null;

  let { id: subGroupId, name: subGroupName } = !!selectedCourseSubGroup && selectedCourseSubGroup;


  useEffect(() => {
    if (
      (hasCourseGroup && !courseGroupId) ||
      !studentBatchId ||
      type === null
    ) {
      navigate("/program");
    }
  }, [hasCourseGroup]);

  const subGroupList = useQuery({
    queryKey: [GET_SUB_GROUP, studentBatchId, courseGroupId],
    queryFn: () => getSubGroup({ studentBatchId, courseGroupId }),
    enabled: !!studentBatchId && !!courseGroupId && hasSubGroups,
  });

  const courseList = useQuery({
    queryKey: [GET_COURSE_BY_ID, studentBatchId, type, courseGroupId, hasSubGroups ? subGroupId : null],
    queryFn: () => getCourse({ studentBatchId, type, courseGroupId, ...(hasSubGroups && { subGroupId }) }),
    enabled: !!studentBatchId && (!!type || type === 0),
  });



  return {
    courseList,
    courseGroupId,
    name,
    subGroupName,
    courseType: type,
    hasCourseGroup,
    displayName,
    hasSubGroups,
    subGroupList
  };
};
